import React from "react";
import { Box, FormControl, MenuItem, Select } from "@mui/material";
import { Controller } from "react-hook-form";

export const CustomSelect = ({ control, name, label, options, placeholder }) => {
  return (
    <div className="bo-input">
      <label className="bo-input__label">
        <p className="bo-input__label-text">{label}</p>
        <div className="bo-input__wrap">
          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              <Controller
                name={name}
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    className="bo-select"
                    variant="standard"
                    displayEmpty
                    MenuProps={{ className: "bo-select-content" }}
                  >
                    {placeholder && <MenuItem value=""><em>{placeholder}</em></MenuItem>}
                    {options.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
            </FormControl>
          </Box>
        </div>
      </label>
    </div>
  );
};